'use strict';
var $, perflibLoader;

require('../../src/frontend/core/dom_js_shim');

perflibLoader = require('../../src/frontend/core/perflibLoader');

perflibLoader();

$ = window.$ = window.jQuery = require('jquery');

require('../../src/frontend/core/jquery.safe-ready')($);

require('../../src/frontend/core/jquery.addons')($);

require('./groupon_modules/placeholder_field')($);

require('./common/core_libraries');

